import React from "react";

const BORDER = "border-8 border-brand bg-light";

const HalfRound = ({ onClick, pattern, opacityClass }) => (
  <div
    className={`relative w-60 h-32 ${BORDER} rounded-t-full overflow-hidden ${opacityClass}`}
    onClick={onClick}
  >
    {pattern}
  </div>
);

const HalfRoundExtendedLeg = ({ onClick, pattern, opacityClass }) => (
  <>
    <div
      className={`relative w-60 h-32 ${BORDER} border-b-0 rounded-t-full overflow-hidden ${opacityClass}`}
      onClick={onClick}
    >
      {pattern}
    </div>
    <div
      className={`relative w-60 ${BORDER} ${opacityClass}`}
      style={{ height: "160px" }}
      onClick={onClick}
    >
      {pattern}
    </div>
  </>
);

const Octagon = ({ onClick, pattern, opacityClass }) => (
  <div className={`relative w-60 h-60 ${opacityClass}`} onClick={onClick}>
    <svg
      className="absolute inset-0 w-full h-full"
      viewBox="-4 -4 248 248"
      xmlns="http://www.w3.org/2000/svg"
    >
      <polygon
        points="70,0 170,0 240,70 240,170 170,240 70,240 0,170 0,70"
        className="fill-slate-100 stroke-orange-500"
        strokeWidth="8"
      />
    </svg>
    <div
      className="absolute inset-0 overflow-hidden"
      style={{
        clipPath:
          "polygon(29% 0%, 71% 0%, 100% 29%, 100% 71%, 71% 100%, 29% 100%, 0% 71%, 0% 29%)",
      }}
    >
      {pattern}
    </div>
  </div>
);

const Circle = ({ onClick, pattern, opacityClass }) => (
  <div
    className={`relative w-60 h-60 ${BORDER} rounded-full overflow-hidden ${opacityClass}`}
    onClick={onClick}
  >
    {pattern}
  </div>
);

const Eyebrow = ({ onClick, pattern, opacityClass }) => (
  <div
    className={`relative w-80 h-20 ${BORDER} overflow-hidden ${opacityClass}`}
    style={{ borderRadius: "50% 50% 0 0 / 100% 100% 0 0" }}
    onClick={onClick}
  >
    {pattern}
  </div>
);

const AnyOther = ({ onClick, pattern, opacityClass }) => (
  <div
    className={`relative w-60 h-60 bg-light border-8 border-dashed border-brand ${opacityClass}`}
    onClick={onClick}
  >
    {pattern}
  </div>
);

const SHAPES = {
  "Half Round": HalfRound,
  "Half Round w/ Extended Leg": HalfRoundExtendedLeg,
  Octagon: Octagon,
  Circle: Circle,
  Eyebrow: Eyebrow,
  "Any Other": AnyOther,
};

const ArchitecturalShapeSelector = ({ architecturalStyle, ...props }) => {
  const Shape = SHAPES[architecturalStyle] || HalfRound;
  return <Shape {...props} />;
};

export default ArchitecturalShapeSelector;
